import "es6-shim";
import "../../styles/Main.css";
import "../../styles/Buttons.css";
import * as React from "react";
import { LabelledInput } from "../customFormComponents/LabelledInput";
import TimerManager from "../../services/TimerManager";
import { IClinicLoginProps } from "./Types";
import { customHooks } from "./Hooks";
import { useEffect, useState } from "react";
import { LanguageCodes } from "../../constants/languages";
import { Loader } from "../genericComponents/Loader/Loader";
import {
    ILoginPageStrings,
    loginPageText,
} from "./LoginLanguageService";
import { HeaderBanner } from "../HeaderBanner";
import { LabelledMaskedInput } from "../customFormComponents/LabelledMaskedInput";


export const ClinicLogin = (props: IClinicLoginProps) => {
    const textString: ILoginPageStrings = loginPageText[navigator.language.substring(0, 2) as LanguageCodes];
    const [userName, , userNameProps] = customHooks(textString.UserNameLabel, "userNameInput", props.connectKeyboard);
    const [password, , passwordProps] = customHooks(textString.PasswordLabel, "passwordInput", props.connectKeyboard);
    const [authenticationCode, setAuthenticatorCode] = useState("");

    const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.keyCode === 13) {
            props.onLogin(userName, password, authenticationCode);
            passwordProps.onChange("");
        }
    }

    useEffect(() => {
        TimerManager.stopTimer();
    }, [])
    let unmaskedAuthenticatorCode = authenticationCode.replace(/[^0-9]/g,"");

    return (
        <div onClick={e => props.disconnectKeyboard()}>
            <HeaderBanner
                largeLogoSize={true}
                locale={navigator.language.substring(0, 2) as LanguageCodes}
            />
            <div style={{ position: "fixed", top: "57px", left: "57px" }}>
                <button
                    className="btn btn-lg btn-primary"
                    onClick={() => window.location.reload()}
                >
                    <i className="fa fa-refresh" aria-hidden="true" />
                </button>
            </div>
            <div style={{ position: "fixed", top: "35px", right: "57px" }}>
                <h3>{process.env.VERSION}</h3>
            </div>
            <div>
                <div className="row">
                    <div className="col-md-10 col-sm-offset-1 text-center">
                        <h1 className="login-title">{textString.LoginPagetitle}</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6 col-sm-offset-3" style={{ paddingTop: "30px" }}>
                        <LabelledInput
                            {...userNameProps}
                            erasable={!props.isConnecting}
                            readOnly={props.isConnecting}
                            isValid={!props.alreadySubmitted || !!userName}
                            focused={props.focusedElementId === "userNameInput"}
                            onKeyDown={onKeyDown}
                            ignoreValidationBlockSpacing
                        />
                        {
                            !props.isConnecting && (
                                <LabelledInput
                                    {...passwordProps}
                                    password={true}
                                    focused={props.focusedElementId === "passwordInput"}
                                    isValid={!props.alreadySubmitted || !!password}
                                    readOnly={props.isConnecting}
                                    onKeyDown={onKeyDown}
                                    ignoreValidationBlockSpacing
                                />
                            )
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-8 col-sm-offset-2">
                        <p style={{ fontSize: "3rem", textAlign: "center", marginTop: "20px" }}>{textString.IfMfaApplicableMessage}</p>
                    </div>
                </div>
                {!props.isConnecting && (
                    <div className="row">
                        <div className="col-sm-6 col-sm-offset-3">
                            <LabelledMaskedInput
                                inputStyles={{ fontSize: "3rem", textAlign: "center" }}
                                labelText={textString.AuthenticatorCodeLabel}
                                value={authenticationCode}
                                focused={props.focusedElementId === "authenticationCodeInput"}
                                isValid={!props.alreadySubmitted || authenticationCode.length === 6}
                                readOnly={props.isConnecting}
                                mask="1 1 1 1 1 1"
                                placeHolder="1 1 1 1 1 1"
                                erasable={false}
                                onChange={value => setAuthenticatorCode(value)}
                                onFocus={() => props.connectKeyboard(value => setAuthenticatorCode(value), authenticationCode, "authenticationCodeInput", "1 1 1 1 1 1")}
                                ignoreValidationBlockSpacing
                            />
                        </div>
                    </div>
                )}
                <div className="row">
                    <div className="col-sm-6 col-sm-offset-3">
                        {
                            !props.isValidLogin &&
                            <h3 id="invalid-block">{textString.LoginFailedMessage}</h3>
                        }
                        {
                            props.isConnecting &&
                            <div id="acquiringHealthCardLoadingSpinner" className="text-center">
                                <Loader />
                                <br />
                            </div>
                        }
                        <div className="text-center" style={{ width: "100%" }}>
                            <button
                                id="submitLoginInformationButton"
                                disabled={props.isConnecting || !userName.trim() || !password.trim() || (unmaskedAuthenticatorCode.length > 0 && unmaskedAuthenticatorCode.length < 6)}
                                className="buttons-blue"
                                onClick={() => {
                                    props.onLogin(userName, password, unmaskedAuthenticatorCode);
                                    passwordProps.onChange("");
                                    setAuthenticatorCode("");
                                }}
                            >
                                {textString.LoginButton}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/ClinicLoginPage/ClinicLoginPage.component.tsx